import { FlightsSimpleLocalizationTemplate } from 'types/shared';

export function flightsSimpleLocalizationTemplate(
  localizationTemplate: FlightsSimpleLocalizationTemplate,
  replacerStrings: string[]
): string {
  const { tokens, template } = localizationTemplate;
  let localizedString = template;

  tokens.forEach((token, index) => {
    const re = new RegExp(`${token}`, 'g');
    localizedString = localizedString.replace(re, replacerStrings[index]);
  });

  return localizedString;
}
